import {getGroovyFuncs} from "../../utils/util";

/**
 * Removes all attributes from mapping objects except: id, file, resourcetype, namespace path, value, and driving
 * @param mappings
 * @param client_id
 * @param sampleData
 * @param useCache
 * @param file
 * @param engineType
 * @param groovyFuncs
 * @returns {Promise<{_DATA: [*], _CONFIG: {STDLIB: *, FHIR_MAPPING, FILE_COLUMN, CLIENT_ID, CACHE: boolean}}>}
 */
export async function createJSONtoFHIRRequestBody(mappings, client_id, sampleData, useCache=false, file, engineType="JSON", groovy = null) {
    let fhir_mapping = mappings.map(({
                                         business_term,
                                         editable,
                                         notes,
                                         slice,
                                         type,
                                         version,
                                         must_support,
                                         client_id,
                                         number,
                                         ...keepAttrs
                                     }) => keepAttrs)
    // fetch groovyFuncs if not passed in              
    let groovyFuncs = groovy ? groovy : await getGroovyFuncs({client_id});

    return {
        _DATA: [sampleData],
        _CONFIG: {
            FILE_COLUMN: file,
            FHIR_MAPPING: fhir_mapping,
            STDLIB: groovyFuncs,
            CACHE: useCache,
            CLIENT_ID: client_id,
            ENGINE_TYPE: engineType,
            DEBUG: false
        },
    }
}